<template>
  <div class="rotate__container hide-mobile-action">
    <div class="rotate__line"></div>
    <div class="rotate__circle" @mousedown="start()"></div>
  </div>
</template>

<script>
export default {
  name: "RotateComponent",
  props: {
    target: { required: true },
    config: {
      required: true,
      validator: v => {
        return v && v.rotation;
      }
    }
  },
  components: {},
  data() {
    return {
      enabled: false
    };
  },
  methods: {
    start() {
      this.enabled = true;
    },
    stop() {
      this.enabled = false;
    },
    update(cursor) {
      if (!this.enabled) {
        return;
      }

      if (!this.target) {
        console.warn("[ROTATION] Property target is undefined");
        return;
      }

      let target = this.element().getBoundingClientRect();
      let targetCenter = {
        x: target.x + target.width / 2,
        y: target.y + target.height / 2
      };
      let cursorCenter = {
        x: cursor.clientX,
        y: cursor.clientY
      };

      let distance = {
        x: targetCenter.x - cursorCenter.x,
        y: targetCenter.y - cursorCenter.y
      };

      let angle = Math.atan2(distance.y, distance.x) * (180 / Math.PI) + 90;
      if (angle < 2 && angle > -2) {
        angle = 0;
      } else if (angle < 92 && angle > 88) {
        angle = 90;
      } else if (angle < 272 && angle > 268) {
        angle = 270;
      } else if (angle < 182 && angle > 178) {
        angle = 180;
      }

      this.apply(`${angle}deg`);
    },
    apply(angle) {
      let actualDevice = document.querySelectorAll('[data-device].editor-container')[0].getAttribute('data-device');


    // console.log(actualDevice);
      let {
        dataset: { device }
      } = document.querySelector(".editor-container");

      if(typeof actualDevice !== 'undefined') {
        device = actualDevice;
      }
      if (device != "desktop") {
        return;
      }

      this.config.rotation = angle;
      if (this.target) {
        let el = this.element();
        el.style.transform = `rotate(${this.config.rotation})`;
        let oel = el.querySelector('.default-resource_components')
        if(oel) {
          oel.style.transform = `rotate(calc(${this.config.rotation} * -1))`;
        }
      } else {
        setTimeout(() => this.apply(this.config.rotation), 100);
      }
    },
    element() {
      if (!this.target) {
        return null;
      }
      if (this.target instanceof HTMLElement) {
        return this.target;
      }
      return this.target.$el;
    }
  },
  mounted() {
    this.apply(this.config.rotation);

    window.addEventListener("mousemove", this.update);
    window.addEventListener("mouseup", this.stop);
    window.addEventListener("mouseleave", this.stop);
  },
  destroyed() {
    window.removeEventListener("mousemove", this.update);
    window.removeEventListener("mouseup", this.stop);
    window.removeEventListener("mouseleave", this.stop);
  }
};
</script>

<style lang="sass" scoped>
$primary: #007bff

.rotate__container
  display: flex
  flex-direction: column
  align-items: center
  position: absolute
  bottom: 0
  left: 50%
  transform: translate(-50%, 100%)
  visibility: hidden
  .rotate__line
    display: block
    height: 24px
    width: 2px
    background-color: $primary
  .rotate__circle
    display: flex
    align-items: center
    justify-content: center
    height: 16px
    width: 16px
    background-color: $primary
    border-radius: 100%
    cursor: pointer
    box-shadow: 0 1px 3px 0 rgba(43,86,114,.43)
    &:before
      content: ""
      height: 8px
      width: 8px
      background-color: #fff
      border-radius: 100%

.widget-focused:not([data-editing="true"]), .widget-focused:not([data-editing="true"])>.vdr
  &> .rotate__container, &> .rotate-target > .rotate__container
    visibility: visible
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/Rotate.vue